import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import { Reveal } from "../landing/Reveal";

const STATS = [
  { emoji: "🍲", value: 4542, label: "Meals Donated", story: "Every unsold meal from FoodBite kitchens feeds someone tonight." },
  { emoji: "🌾", value: 1210, label: "Farmers Supported", story: "Farm-to-campus in 24 hours means farmers earn fairly, students eat fresh." },
  { emoji: "🌍", value: 15, label: "Tons of Food Saved", story: "Surplus becomes dinner, not landfill. Your orders make it happen." },
];

const Counter = ({ target, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const c = animate(0, target, { duration: 2, ease: "easeOut", onUpdate: setVal });
    return () => c.stop();
  }, [inView, target]);
  return (
    <span ref={ref}>
      {Math.round(val).toLocaleString("en-IN")}{suffix}
    </span>
  );
};

export const GreenBite = () => (
  <section id="greenbite" data-testid="greenbite-section" className="relative overflow-hidden py-20 sm:py-24">
    <div aria-hidden="true" className="absolute left-1/2 top-1/2 h-[440px] w-[680px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#06B6D4]/[0.08] blur-[150px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">🌱 GreenBite</p>
        <h2 className="mx-auto mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Every bite leaves the campus better.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={0.08 * i} className="h-full">
            <div
              data-testid={`green-stat-${i}`}
              className="flex h-full flex-col rounded-3xl border border-[#06B6D4]/20 bg-gradient-to-b from-[#06B6D4]/[0.08] to-transparent p-7 backdrop-blur-xl transition-transform duration-300 hover:-translate-y-1.5"
            >
              <span className="text-4xl">{s.emoji}</span>
              <p className="mt-5 font-display text-4xl font-black tracking-tight text-white sm:text-5xl">
                <Counter target={s.value} />
              </p>
              <p className="mt-1 font-jbmono text-[10px] uppercase tracking-widest text-[#06B6D4]">
                {s.label}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-slate-400">{s.story}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <p className="mt-8 text-center font-jbmono text-[10px] uppercase tracking-widest text-slate-600">
        Illustrative impact figures for demo purposes
      </p>
    </div>
  </section>
);
